import { render, staticRenderFns } from "./InfoIndex.vue?vue&type=template&id=c3c34da2&"
import script from "./InfoIndex.vue?vue&type=script&lang=js&"
export * from "./InfoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports